import React from "react";
import HtmlParser from "react-html-parser";
import { Col, Container, Row } from "react-bootstrap";
import Press_bg from "../../images/press/press.png";

function Banner({ data }) {
  return (
    // <div className="services_banner press_banners" style={{backgroundImage: `url(${Press_bg})`}}>
    //     <Container className="h-100">
    //         <Row className="h-100">
    //             <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
    //                 <div className="banenr_content">
    //                     <div className="example" data-text={data?.button_body_txt}>
    //                         <h1>{data?.name}</h1>
    //                     </div>
    //                     <div className="banner_content_txt listing_flex">
    //                         {HtmlParser(data?.content)}
    //                     </div>
    //                 </div>
    //             </Col>
    //         </Row>
    //     </Container>
    // </div>
    <div
      className="services_banner press_banners"
      style={{
        backgroundImage:
          "url(/static/press-65c8363539196606e3402081c6cc9a0f.png)",
      }}
    >
      <div className="h-100 container">
        <div className="h-100 row">
          <div className="my-auto col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-12">
            <div className="banenr_content">
              <div className="example" data-text="Publications">
                <h1>OUR PUBLICATIONS</h1>
              </div>
              <div className="banner_content_txt listing_flex">
                <p>
                  <strong>
                    We share our expertise in software development services,
                    including web, mobile, design, and DevOps, with various
                    platforms.
                  </strong>
                </p>
                <ul>
                  <li>Press Releases</li>
                  <li>Features</li>
                  <li>Awards</li>
                  <li>News</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Banner;
